// 현장 A/S 액션(rpc) — 직원이 상태를 바꾼다(접수 → 방문 예정 → 처리 완료).
import { rpc } from "@/api/client";

export const setAsRequestStatus = (input: unknown) => rpc("as-request/actions/setAsRequestStatus", input);
